import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './i18n/config';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { createLightTheme } from './theme/theme';

function ThemedApp() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const theme = useMemo(
    () => createLightTheme(isRTL ? 'rtl' : 'ltr'),
    [isRTL]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemedApp />
    </ErrorBoundary>
  </React.StrictMode>
);
